var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-blog text-left iq-ptb-30 iq-pr-30 iq-pl-30",class:_vm.active ? 'active' : ''},[_c('div',[_vm._t("cardIcon"),_vm._v(" "),_vm._t("cardTitle")],2),_vm._v(" "),_c('div',{staticClass:"content-blog"},[_vm._t("cardBody"),_vm._v(" "),_vm._t("cardFooter")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }